module.exports = __webpack_public_path__ + "img/siwei-qrcode.20b3cd49.png";